import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { LinearGradient } from "expo-linear-gradient";
import { useFragment } from "react-relay";

import { DepartmentIcon } from "@whoosh/design-system/src/components/icons_v2/department";
import {
  VStack,
  Text,
  Box,
} from "@whoosh/design-system/src/components/primitive";

import { InviteCardTopSection_Booking$key } from "./__generated__/InviteCardTopSection_Booking.graphql";

export const InviteCardTopSection = ({
  bookingRef,
}: {
  bookingRef: InviteCardTopSection_Booking$key | null;
}) => {
  const data = useFragment(InviteCardTopSectionFragmentString, bookingRef);
  const ownerName = `${data?.ownerClient?.firstName} ${data?.ownerClient?.lastName}`;
  const departmentType =
    data?.startSlot?.agenda?.facility?.department?.type ?? "GOLF";
  const departmentTypeCapitalized =
    departmentType.charAt(0).toUpperCase() +
    departmentType.slice(1).toLowerCase();

  return (
    <VStack
      height={136}
      width="100%"
      alignItems="center"
      borderBottomWidth={1}
      borderColor="outline-default"
    >
      <LinearGradient
        // Background Linear Gradient
        colors={["#EDEDED", "#F7F7F7"]}
        style={{
          position: "absolute",
          left: 0,
          right: 0,
          bottom: 0,
          top: 0,
        }}
      />
      <Box
        width={40}
        height={40}
        marginTop={5}
        marginBottom={3}
        style={{ borderRadius: 20 }}
        backgroundColor="surface-primary"
        alignItems="center"
        justifyContent="center"
      >
        <DepartmentIcon type={departmentType} />
      </Box>
      <Text variant="mainSmallSemiBold">{t`You have been invited to`}</Text>
      <Text variant="mainHeading">{t`${ownerName}'s ${departmentTypeCapitalized} Booking`}</Text>
    </VStack>
  );
};

const InviteCardTopSectionFragmentString = graphql`
  fragment InviteCardTopSection_Booking on Booking {
    id
    ownerClient {
      ... on Customer {
        firstName
        lastName
      }
      ... on Member {
        firstName
        lastName
      }
    }
    startSlot {
      agenda {
        facility {
          department {
            type
          }
        }
      }
    }
  }
`;
